import { ComponentProps } from "react";

export default function AirPlaneIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={800}
      height={800}
      viewBox="0 0 485.641 485.641"
      xmlSpace="preserve"
      className="size-6"
      fill="currentColor"
      {...props}
    >
      <path d="M467.44 109.264c-25.459-13.141-71.192-23.554-159.117 45.681-19.059 15.009-107.356 81.918-125.079 98.352-17.015 15.779-33.936 31.674-50.548 47.877-3.772 3.681-7.544 7.362-11.305 11.056l-93.623-44.961c-8.075-3.884-18.044-1.745-23.735 5.635-6.535 8.476-4.963 20.645 3.513 27.18l99.087 76.411c.309.235 20.145 17.165 41.042 5.167 17.429-10.007 34.815-20.109 52.005-30.521 20.242-12.258 40.359-24.715 60.4-37.299 17.423-10.941 34.736-22.061 51.993-33.264l-4.554 54.834c-1 12.608 7.632 24.328 20.343 26.733 13.617 2.576 26.746-6.373 29.323-19.99l19.738-104.292c1.603-1.07 3.211-2.127 4.812-3.198 18.932-12.664 36.955-26.428 54.75-40.682 26.439-21.176 76.021-62.751 30.955-84.719" />
      <path d="m173.896 216.962 34.464 1.797c23.886-18.829 54.341-42.175 74.378-57.595l-108.842 5.676c-12.628.704-23.079 10.836-23.753 23.755-.722 13.84 9.912 25.645 23.753 26.367" />
    </svg>
  );
}
